exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header[data-v-1601c773] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n.modal-close[data-v-1601c773] {\n  cursor: pointer;\n}\n@media (max-width: 400px) {\n.modal-content[data-v-1601c773] {\n    padding-left: 20px;\n    padding-right: 20px;\n}\n}\n", ""]);

// exports
